import type { FaireBrandEntity } from "../../entity_types/brand";

// Lynn & Liana Designs (b_16l4jf5hzo). Identity from ANALYTICS.CANONICAL.BRANDS
// on 2026-09-23. Full API-imported media (avatar/banner) was not available at
// write time, so this shard carries the fields the advertiser profile needs
// for validation and display.
export const b_16l4jf5hzo: FaireBrandEntity = {
  token: "b_16l4jf5hzo",
  type: "brand",
  name: "Lynn & Liana Designs",
  location: "Steinbach, MB, CAN",
  isTopShop: true,
  meta: {
    source: "snowflake",
    importedAt: "2026-09-23T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
